import classNames from 'classnames';
import { FormikProps } from 'formik';
import React from 'react';
import { FormikTextField } from '../Components/FormikFields/FormikTextField';
import styles from './RegisterDeviceFields.module.scss';
import { RegisterDeviceFormState } from './RegisterDeviceForm';

export type InputFieldsProps = {
    formProps: FormikProps<RegisterDeviceFormState>;
};

const FormGrouping: React.FC<{ title: string; columns?: 2 | 3 }> = props => {
    return (
        <div className={classNames(styles.formDetails, { [styles.threeColumn]: props.columns === 3 })}>
            <h3 className={styles.formGroupHeading}>{props.title}</h3>
            {props.children}
        </div>
    );
};

export const RegisterDeviceFields = (props: InputFieldsProps) => {
    return (
        <div className={styles.form}>
            <FormGrouping title='Customer Identifiers'>
                <FormikTextField testId='customer-name' name='customerName' label='Customer name' required />
                <FormikTextField testId='customer-auth-system' name='customerAuthSystem' label='Auth system' required />
                <div className={styles.fullWidthField}>
                    <FormikTextField
                        testId='customer-auth-system-key'
                        name='customerAuthSystemKey'
                        label='Auth system key'
                        required
                    />
                </div>
            </FormGrouping>
            <FormGrouping title='PRODA Details' columns={3}>
                <FormikTextField testId='device-name' name='deviceName' label='PRODA device name' required />
                <FormikTextField
                    testId='device-activation-code'
                    name='deviceActivationCode'
                    label='PRODA activation code'
                    required
                />
                <FormikTextField
                    testId='device-organisation-identifier'
                    name='deviceOrganisationIdentifier'
                    label='PRODA organisation ID'
                    required
                />
            </FormGrouping>
            <FormGrouping title='Device Identifiers'>
                <FormikTextField
                    testId='device-authoring-system'
                    name='deviceAuthoringSystem'
                    label='Authoring system'
                    required
                />
                <FormikTextField
                    testId='device-authoring-system-key'
                    name='deviceAuthoringSystemKey'
                    label='Authoring system key'
                    required
                />
            </FormGrouping>
            <FormGrouping title='Messaging'>
                <div className={styles.fullWidthField}>
                    <FormikTextField testId='device-queue-name' name='deviceQueueName' label='Queue name' required />
                </div>
            </FormGrouping>
            <FormGrouping title='Health System Application'>
                <FormikTextField
                    testId='health-system-application-name'
                    name='healthSystemApplicationName'
                    label='Application name'
                    helperText='dhs-productId'
                    required
                />
                <FormikTextField
                    testId='health-system-application-xibmclient-identifier'
                    name='healthSystemApplicationXIBMClientIdentifier'
                    label='Application Client ID'
                    helperText='X IBM Client ID'
                    required
                />
                <div className={styles.fullWidthField}>
                    <FormikTextField
                        testId='health-system-application-client-identifier'
                        name='healthSystemApplicationClientIdentifier'
                        label='PRODA Client ID'
                        required
                    />
                </div>
            </FormGrouping>
        </div>
    );
};
